import axios from "axios";
import {
	FETCH_COUPONS,
	FETCH_STORES,
	FETCH_CATEGORIES,
	CREATE_COUPON,
	CREATE_STORE,
	UPDATE_COUPON,
	DELETE_COUPON,
	CREATE_COUPON_IMAGE,
	FETCH_COUPON_DATA,
	EDIT_COUPON_IMAGE,
	CREATE_STORE_IMAGE,
	EDIT_STORE_IMAGE,
	FETCH_BAR_CATEGORY,
	CREATE_CATEGORY_IMAGE,
	EDIT_CATEGORY_IMAGE,
} from "constants/ActionTypes";

const ROOT_URL = "https://appvendedores.comprasdavivienda.cr/resources/ws/";

export function fetchCoupons(
	callback = () => {
		console.log();
	}
) {
	const ROUTINES = "getCoupons.php/getCoupons";
	const url = `${ROOT_URL}${ROUTINES}`;
	const request = axios
		.get(url)
		.then((request) => request.data.result)
		.then(callback());
	return {
		type: FETCH_COUPONS,
		payload: request,
	};
}

export function fetchCouponsData(
	{ storeId, dateFrom, dateTo },
	callback = () => {
		console.log();
	}
) {
	const ROUTINES = `getCouponsData.php/getDataCoupons?storeId=${storeId}&dateFrom=${dateFrom}&dateTo=${dateTo}`;
	const url = `${ROOT_URL}${ROUTINES}`;
	const request = axios
		.get(url)
		.then((request) => {
			if (request.data.success == 1) {
				return request.data.result;
			} else {
				return [];
			}
		})
		.then(callback());
	return {
		type: FETCH_COUPON_DATA,
		payload: request,
	};
}

export function createCoupon(
	{
		category,
		creationDay,
		description,
		ticketName,
		points,
		active,
		branchOffice,
	},
	callback
) {
	const ROUTINES = `insertCoupon.php/insertCoupon?categoryId=${category}&creationDate=${creationDay}&description=${description}&name=${ticketName}&points=${points}&state=${active}&storeId=${branchOffice}`;
	const url = `${ROOT_URL}${ROUTINES}`;
	const request = axios
		.get(url)
		.then((request) => request.success)
		.then(callback());
	return {
		type: CREATE_COUPON,
		payload: request,
	};
}

export function createCouponWithImage(
	{
		category,
		creationDay,
		description,
		ticketName,
		points,
		active,
		branchOffice,
		imageUrl,
		expirationDay,
	},
	callback
) {
	const formData = new FormData();
	formData.append("categoryId", category);
	formData.append("creationDate", creationDay);
	formData.append("description", description);
	formData.append("name", ticketName);
	formData.append("points", points);
	formData.append("state", active);
	formData.append("storeId", branchOffice);
	formData.append("expirationDate", expirationDay);
	formData.append("command", "upload");
	formData.append("file", imageUrl);

	const config = {
		headers: { "Content-Type": "multipart/form-data" },
	};

	const ROUTINES = `imageapi/`;
	const url = `${ROOT_URL}${ROUTINES}`;
	const request = axios
		.post(url, formData, config)
		.then(function (response) {
			console.log("response", response);
		})
		.then(
			(request) => {
				request;
			},
			(error) => {
				console.log(error);
			},
			function (response) {
				console.log("response", response);
			}
		)
		.then(callback());
	return {
		type: CREATE_COUPON_IMAGE,
		payload: request,
	};
}

export function createCategoryWithImage(
	{ name, active, order, imageUrl },
	callback
) {
	const formData = new FormData();
	formData.append("name", name);
	formData.append("status", active);
	formData.append("sort_order", order);
	formData.append("command", "uploadCat");
	formData.append("file", imageUrl);

	const config = {
		headers: { "Content-Type": "multipart/form-data" },
	};

	const ROUTINES = `imageapi/`;
	const url = `${ROOT_URL}${ROUTINES}`;
	const request = axios
		.post(url, formData, config)
		.then(function (response) {
			console.log("response", response);
		})
		.then(
			(request) => {
				request;
			},
			(error) => {
				console.log(error);
			},
			function (response) {
				console.log("response", response);
			}
		)
		.then(callback());
	return {
		type: CREATE_CATEGORY_IMAGE,
		payload: request,
	};
}

export function editCouponWithImage(
	{
		category,
		creationDay,
		description,
		ticketName,
		points,
		active,
		branchOffice,
		imageUrl,
		id,
		expirationDay,
	},
	callback
) {
	const formData = new FormData();
	formData.append("categoryId", category);
	formData.append("creationDate", creationDay);
	formData.append("description", description);
	formData.append("name", ticketName);
	formData.append("points", points);
	formData.append("state", active);
	formData.append("storeId", branchOffice);
	formData.append("couponId", id);
	formData.append("expirationDate", expirationDay);

	formData.append("command", "uploadEdit");
	formData.append("file", imageUrl);

	const config = {
		headers: { "Content-Type": "multipart/form-data" },
	};

	const ROUTINES = `imageapi/`;
	const url = `${ROOT_URL}${ROUTINES}`;
	const request = axios
		.post(url, formData, config)
		.then(function (response) {
			console.log("response", response);
		})
		.then(
			(request) => {
				request;
			},
			(error) => {
				console.log(error);
			},
			function (response) {
				console.log("response", response);
			}
		)
		.then(callback());
	console.log(request);
	return {
		type: EDIT_COUPON_IMAGE,
		payload: request,
	};
}

export function editCategoryImage({ name, order, imageUrl, id }, callback) {
	const formData = new FormData();
	formData.append("name", name);
	formData.append("categoryId", id);
	formData.append("sortOrder", order);

	formData.append("command", "uploadEditCat");
	formData.append("file", imageUrl);

	const config = {
		headers: { "Content-Type": "multipart/form-data" },
	};

	const ROUTINES = `imageapi/`;
	const url = `${ROOT_URL}${ROUTINES}`;
	const request = axios
		.post(url, formData, config)
		.then(function (response) {
			console.log("response", response);
		})
		.then(
			(request) => {
				request;
			},
			(error) => {
				console.log(error);
			},
			function (response) {
				console.log("response", response);
			}
		)
		.then(callback());
	console.log(request);
	return {
		type: EDIT_CATEGORY_IMAGE,
		payload: request,
	};
}

export function updateCoupon(
	{
		category,
		creationDay,
		description,
		ticketName,
		points,
		active,
		branchOffice,
		id,
	},
	callback = () => console.log()
) {
	const ROUTINES = `updateCoupon.php/updateCouponProfile?categoryId=${category}&creationDate=${creationDay}&name=${ticketName}&points=${points}&state=${active}&storeId=${branchOffice}&description=${description}&id=${id}`;
	const url = `${ROOT_URL}${ROUTINES}`;
	const request = axios
		.get(url)
		.then((request) => request.success)
		.then(callback());
	return {
		type: UPDATE_COUPON,
		payload: request,
	};
}

export function deleteCoupon(
	{ categoryId, creationDate, description, name, points, storeId, id },
	callback = () => console.log()
) {
	const ROUTINES = `updateCoupon.php/updateCouponProfile?categoryId=${categoryId}&creationDate=${creationDate}&name=${name}&points=${points}&state=${0}&storeId=${storeId}&description=${description}&id=${id}`;
	const url = `${ROOT_URL}${ROUTINES}`;
	const request = axios
		.get(url)
		.then((request) => request.success)
		.then(callback());
	return {
		type: DELETE_COUPON,
		payload: request,
	};
}

export function createStoreWithImage(
	{ name, email, phone, active, imageUrl },
	callback
) {
	const formData = new FormData();
	formData.append("name", name);
	formData.append("email", email);
	formData.append("phone", phone);
	formData.append("state", active);
	formData.append("command", "uploadStore");
	formData.append("file", imageUrl);

	const config = {
		headers: { "Content-Type": "multipart/form-data" },
	};

	const ROUTINES = `imageapi/`;
	const url = `${ROOT_URL}${ROUTINES}`;
	const request = axios
		.post(url, formData, config)
		.then(function (response) {
			console.log("response", response);
		})
		.then(
			(request) => {
				request;
			},
			(error) => {
				console.log(error);
			},
			function (response) {
				console.log("response", response);
			}
		)
		.then(callback());
	console.log(request);
	return {
		type: CREATE_STORE_IMAGE,
		payload: request,
	};
}

export function editStoreImage(
	{ name, email, phoneNumber, imageUrl, id },
	callback
) {
	const formData = new FormData();
	formData.append("name", name);
	formData.append("email", email);
	formData.append("phone", phoneNumber);
	formData.append("state", 1);
	console.log("active");
	formData.append("storeId", id);
	formData.append("command", "uploadEditStore");
	formData.append("file", imageUrl);

	const config = {
		headers: { "Content-Type": "multipart/form-data" },
	};

	const ROUTINES = `imageapi/`;
	const url = `${ROOT_URL}${ROUTINES}`;
	const request = axios
		.post(url, formData, config)
		.then(function (response) {
			console.log("response", response);
		})
		.then(
			(request) => {
				request;
			},
			(error) => {
				console.log(error);
			},
			function (response) {
				console.log("response", response);
			}
		)
		.then(callback());
	console.log(request);
	return {
		type: EDIT_STORE_IMAGE,
		payload: request,
	};
}

export function createStore({ name, email, phone, active }, callback) {
	const ROUTINES = `insertStore.php/insertStore?name=${name}&email=${email}&phone=${phone}&state=${active}`;
	const url = `${ROOT_URL}${ROUTINES}`;
	const request = axios
		.get(url)
		.then((request) => request.success)
		.then(callback());
	return {
		type: CREATE_STORE,
		payload: request,
	};
}

export function fetchStores() {
	const ROUTINES = "getStores.php";
	const url = `${ROOT_URL}${ROUTINES}`;
	const request = axios.get(url).then((request) => {
		return request.data.result;
	});
	return {
		type: FETCH_STORES,
		payload: request,
	};
}

export function fetchCategories() {
	const ROUTINES = "getAllCategories.php/";
	const url = `${ROOT_URL}${ROUTINES}`;
	const request = axios.get(url).then((request) => {
		return request.data.result;
	});
	return {
		type: FETCH_CATEGORIES,
		payload: request,
	};
}



// WEBPACK FOOTER //
// ./src/appRedux/actions/Coupons.js